import React, { useState, useEffect } from 'react';

// --- COMPONENTE POPUP ---
const VisitorPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [count, setCount] = useState(25);

  useEffect(() => {
    // 1. Mostrar el popup después de 10 segundos de montar el componente
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10000);

    // 2. Simulación de cambio de número (live data simulation)
    const interval = setInterval(() => {
      setCount((prevCount) => {
        const randomChange = Math.floor(Math.random() * 5) - 2; // Variación entre -2 y +2
        let newCount = prevCount + randomChange;
        
        // Límites para mantener el realismo
        if (newCount < 15) newCount = 18;
        if (newCount > 45) newCount = 40;
        
        return newCount;
      });
    }, 4500);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Esperar a que termine la animación de salida (700ms) para desmontar
    setTimeout(() => setIsClosed(true), 700);
  };

  // Si el usuario lo cerró definitivamente, no renderizamos nada
  if (isClosed) return null;

  return (
    <>
      <div 
        className={`fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50 flex items-center gap-4 p-4 pr-10 rounded-lg shadow-xl 
        bg-slate-900/85 backdrop-blur-md border border-white/10 text-white 
        transform transition-all duration-700 ease-out max-w-[90vw] md:max-w-sm
        ${isVisible ? 'translate-y-0 opacity-100 visible' : 'translate-y-20 opacity-0 invisible'}`}
      >
        
        {/* Icono / Imagen */}
        <div className="relative flex-shrink-0">
          {/* Icono de ojo */}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          {/* Punto verde de estado */}
          <span className="absolute -top-1 -right-1 h-3 w-3 bg-green-500 rounded-full border-2 border-slate-900 live-dot"></span>
        </div>

        {/* Texto */}
        <div className="text-sm">
          <div className="font-semibold leading-tight">
            <span className="text-indigo-300 font-bold text-lg transition-all duration-200">
              {count}
            </span> personas
          </div>
          <p className="text-slate-300 text-xs">están viendo este sitio ahora mismo.</p>
        </div>

        {/* Botón Cerrar (X) */}
        <button 
          onClick={handleClose} 
          className="absolute top-2 right-2 text-slate-400 hover:text-white transition-colors focus:outline-none"
          aria-label="Cerrar notificación"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Estilos para la animación 'pulse' (Tailwind no tiene keyframes arbitrarios por defecto) */}
      <style>{`
        @keyframes pulse-green {
            0% { box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7); }
            70% { box-shadow: 0 0 0 6px rgba(74, 222, 128, 0); }
            100% { box-shadow: 0 0 0 0 rgba(74, 222, 128, 0); }
        }
        .live-dot {
            animation: pulse-green 2s infinite;
        }
      `}</style>
    </>
  );
};
// --- FIN DEL COMPONENTE POPUP ---

export default VisitorPopup;